var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isYektanetPlt
    ? _c("yektanet-signup")
    : _vm.isLeadPlt
    ? _c("lead-signup")
    : _c("old-signup")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }